import axios from "axios";
import { getAuthToken } from "./authService";
import consola from "consola";

// Create axios instance with default config
const api = axios.create({
  baseURL: process.env.NODE_ENV === "production" ? "" : "http://localhost:5712",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Type": "web",
  },
});

// Add request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    consola.debug("Response:", response);
    return response;
  },
  (error) => {
    consola.debug("interceptor error:", error);
    // Handle session timeout or unauthorized errors
    if (error.response && error.response.status === 401) {
      // Check if the original request URL was /api/users/me
      const originalRequestUrl = error.config?.url;
      const isUserMeEndpoint =
        originalRequestUrl === "/api/users/me" ||
        originalRequestUrl === "http://localhost:5712/api/users/me" ||
        originalRequestUrl === "https://weklean.ca/api/users/me" ||
        originalRequestUrl === "https://nettoigo.ca/api/users/me";

      // Only redirect to login if we're not already on the login page
      // AND it's not the /api/users/me endpoint (which is expected to 401 for logged-out users)
      if (
        typeof window !== "undefined" &&
        !window.location.pathname.includes("/login") &&
        !isUserMeEndpoint
      ) {
        consola.debug(
          "Unauthorized access on a protected endpoint, redirecting to login page"
        );
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// Export the API instance as default
export default api;

// Also export as named export for TypeScript imports
export { api };
